import axios from 'axios_template';

export const createReview = body => {
    return axios.post('/api/users/reviews/', body);
};
